import { render, staticRenderFns } from "./phraseAdd.vue?vue&type=template&id=2aaff6a4&scoped=true"
import script from "./phraseAdd.vue?vue&type=script&lang=js"
export * from "./phraseAdd.vue?vue&type=script&lang=js"
import style0 from "./phraseAdd.vue?vue&type=style&index=0&id=2aaff6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaff6a4",
  null
  
)

export default component.exports